/*! @pentacode/ui v0.1.0 */
import { t as e } from "../../../styledElement-Dm1irIE2.js";
import { t } from "../../../decorateMetadata-BhwOl-pv.js";
import { t as n } from "../../../decorate-DHgd5sZx.js";
import { FormElement as r } from "../../formElement.js";
import "../../../checkbox-BOki-Nk5.js";
import { LitElement as i, html as a } from "lit";
import { customElement as o, property as s, state as c } from "lit/decorators.js";
//#region src/elements/employee-questionnaire/shared/short-term-professionalism-section.ts
var l = class extends e(r(i)) {
	constructor(...e) {
		super(...e), this.data = {
			registeredAsJobSeekerShortTerm: !1,
			receivingAgencyBenefits: !1,
			receivingSocialBenefits: !1,
			parentalLeave: !1,
			militaryOrVoluntaryService: !1,
			federalVoluntaryService: !1,
			startingApprenticeship: !1,
			startingPublicService: !1,
			employmentBetweenTrainingAndStudy: !1,
			employmentBetweenStudyAndWork: !1,
			employmentDuringService: !1,
			recentFixedTermContract: !1,
			sameEmployerBefore: !1,
			newEmploymentAfterPrevious: !1,
			leaveFromMainJob: !1,
			eveningSchoolStudent: !1,
			seasonalHarvestWork: !1
		}, this._registeredAsJobSeekerShortTerm = !1, this._receivingAgencyBenefits = !1, this._receivingSocialBenefits = !1, this._parentalLeave = !1, this._militaryOrVoluntaryService = !1, this._federalVoluntaryService = !1, this._startingApprenticeship = !1, this._startingPublicService = !1, this._employmentBetweenTrainingAndStudy = !1, this._employmentBetweenStudyAndWork = !1, this._employmentDuringService = !1, this._recentFixedTermContract = !1, this._sameEmployerBefore = !1, this._newEmploymentAfterPrevious = !1, this._leaveFromMainJob = !1, this._eveningSchoolStudent = !1, this._seasonalHarvestWork = !1;
	}
	willUpdate(e) {
		e.has("data") && this.data && (this._registeredAsJobSeekerShortTerm = this.data.registeredAsJobSeekerShortTerm, this._receivingAgencyBenefits = this.data.receivingAgencyBenefits, this._receivingSocialBenefits = this.data.receivingSocialBenefits, this._parentalLeave = this.data.parentalLeave, this._militaryOrVoluntaryService = this.data.militaryOrVoluntaryService, this._federalVoluntaryService = this.data.federalVoluntaryService, this._startingApprenticeship = this.data.startingApprenticeship, this._startingPublicService = this.data.startingPublicService, this._employmentBetweenTrainingAndStudy = this.data.employmentBetweenTrainingAndStudy, this._employmentBetweenStudyAndWork = this.data.employmentBetweenStudyAndWork, this._employmentDuringService = this.data.employmentDuringService, this._recentFixedTermContract = this.data.recentFixedTermContract, this._sameEmployerBefore = this.data.sameEmployerBefore, this._newEmploymentAfterPrevious = this.data.newEmploymentAfterPrevious, this._leaveFromMainJob = this.data.leaveFromMainJob, this._eveningSchoolStudent = this.data.eveningSchoolStudent, this._seasonalHarvestWork = this.data.seasonalHarvestWork);
	}
	_handleSectionChange() {
		this.dispatchEvent(new CustomEvent("change", {
			detail: {
				registeredAsJobSeekerShortTerm: this._registeredAsJobSeekerShortTerm,
				receivingAgencyBenefits: this._receivingAgencyBenefits,
				receivingSocialBenefits: this._receivingSocialBenefits,
				parentalLeave: this._parentalLeave,
				militaryOrVoluntaryService: this._militaryOrVoluntaryService,
				federalVoluntaryService: this._federalVoluntaryService,
				startingApprenticeship: this._startingApprenticeship,
				startingPublicService: this._startingPublicService,
				employmentBetweenTrainingAndStudy: this._employmentBetweenTrainingAndStudy,
				employmentBetweenStudyAndWork: this._employmentBetweenStudyAndWork,
				employmentDuringService: this._employmentDuringService,
				recentFixedTermContract: this._recentFixedTermContract,
				sameEmployerBefore: this._sameEmployerBefore,
				newEmploymentAfterPrevious: this._newEmploymentAfterPrevious,
				leaveFromMainJob: this._leaveFromMainJob,
				eveningSchoolStudent: this._eveningSchoolStudent,
				seasonalHarvestWork: this._seasonalHarvestWork
			},
			bubbles: !0,
			composed: !0
		}));
	}
	_renderCheckboxItem(e, t, n, r, i) {
		return a`
            <div class="flex items-center gap-2 px-2">
                <ptc-ui-checkbox
                    id=${e}
                    name=${e}
                    .checked=${r}
                    @change=${(e) => {
			e.stopPropagation(), i(e.detail.checked);
		}}
                ></ptc-ui-checkbox>
                <label for=${e} class="text-sm font-medium text-gray-700">
                    ${t}
                    <span class="block text-xs text-gray-500">${n}</span>
                </label>
            </div>
        `;
	}
	render() {
		return a`
            <section class="w-full">
                <h2 class="mb-2 px-2 text-xl font-semibold">Angaben zur Berufsmäßigkeit</h2>
                <p class="mb-4 px-2 text-sm text-gray-600">
                    Sollte die monatliche Vergütung mindestens einmalig über 556€ liegen, muss die sogenannte
                    "Berufsmäßigkeit" überprüft werden. Bitte kreuzen Sie alle Sachverhalte an, die für Sie zutreffen.
                </p>

                <div class="flex flex-col gap-4">
                    ${this._renderCheckboxItem("registeredAsJobSeekerShortTerm", "Arbeitssuchend", "Sie sind als arbeitssuchend bei der Agentur für Arbeit gemeldet.", this._registeredAsJobSeekerShortTerm, (e) => {
			this._registeredAsJobSeekerShortTerm = e, this._handleSectionChange();
		})}
                    ${this._renderCheckboxItem("receivingAgencyBenefits", "Arbeitslosengeld", "Bezug von Leistungen der Arbeitsagentur (z. B. Arbeitslosengeld)", this._receivingAgencyBenefits, (e) => {
			this._receivingAgencyBenefits = e, this._handleSectionChange();
		})}
                    ${this._renderCheckboxItem("receivingSocialBenefits", "Sozialhilfe", "Bezug von ALG II, Sozialgeld oder Sozialhilfe", this._receivingSocialBenefits, (e) => {
			this._receivingSocialBenefits = e, this._handleSectionChange();
		})}
                    ${this._renderCheckboxItem("parentalLeave", "Elternzeit", "Sie befinden sich in Elternzeit", this._parentalLeave, (e) => {
			this._parentalLeave = e, this._handleSectionChange();
		})}
                    ${this._renderCheckboxItem("militaryOrVoluntaryService", "Schule - Wehrdienst", "Beschäftigung zwischen Schulabschluss und Wehrdienst, Zeitsoldat, Jugendfreiwilligendienst (FSJ/FÖJ)", this._militaryOrVoluntaryService, (e) => {
			this._militaryOrVoluntaryService = e, this._handleSectionChange();
		})}
                    ${this._renderCheckboxItem("federalVoluntaryService", "Schule - Bundesfreiwilligendienst", "Beschäftigung zwischen Schulabschluss und Bundesfreiwilligendienst", this._federalVoluntaryService, (e) => {
			this._federalVoluntaryService = e, this._handleSectionChange();
		})}
                    ${this._renderCheckboxItem("startingApprenticeship", "Schule - Ausbildung", "Beschäftigung zwischen Schulabschluss und Beginn einer Ausbildung oder Dauerbeschäftigung als Arbeitnehmer", this._startingApprenticeship, (e) => {
			this._startingApprenticeship = e, this._handleSectionChange();
		})}
                    ${this._renderCheckboxItem("startingPublicService", "Schule - Beamtenstart", "Beschäftigung zwischen Schulabschluss und Beginn eines beamtenähnlichen Dienstverhältnisses", this._startingPublicService, (e) => {
			this._startingPublicService = e, this._handleSectionChange();
		})}
                    ${this._renderCheckboxItem("employmentBetweenTrainingAndStudy", "Ausbildung - Studium", "Beschäftigung zwischen Abschluss der Ausbildung und Studienbeginn", this._employmentBetweenTrainingAndStudy, (e) => {
			this._employmentBetweenTrainingAndStudy = e, this._handleSectionChange();
		})}
                    ${this._renderCheckboxItem("employmentBetweenStudyAndWork", "Studium - Job", "Beschäftigung zwischen Studienabschluss und dem Eintritt ins Berufsleben", this._employmentBetweenStudyAndWork, (e) => {
			this._employmentBetweenStudyAndWork = e, this._handleSectionChange();
		})}
                    ${this._renderCheckboxItem("employmentDuringService", "Neben Wehrdienst", "Beschäftigung während des freiwilligen Wehrdienstes", this._employmentDuringService, (e) => {
			this._employmentDuringService = e, this._handleSectionChange();
		})}
                    ${this._renderCheckboxItem("recentFixedTermContract", "Kurzzeitvertrag", "Beschäftigung innerhalb eines kürzlich beendeten Rahmenarbeitsvertrags (max. 1 Jahr, max. 2 Monate zurückliegend)", this._recentFixedTermContract, (e) => {
			this._recentFixedTermContract = e, this._handleSectionChange();
		})}
                    ${this._renderCheckboxItem("sameEmployerBefore", "Gleicher Arbeitgeber", "Unmittelbar zuvor beim selben Arbeitgeber beschäftigt", this._sameEmployerBefore, (e) => {
			this._sameEmployerBefore = e, this._handleSectionChange();
		})}
                    ${this._renderCheckboxItem("newEmploymentAfterPrevious", "Anschluss - Job", "Beschäftigung direkt nach einer anderen Tätigkeit mit Versicherungspflicht bei einem anderen Arbeitgeber", this._newEmploymentAfterPrevious, (e) => {
			this._newEmploymentAfterPrevious = e, this._handleSectionChange();
		})}
                    ${this._renderCheckboxItem("leaveFromMainJob", "Urlaub", "Paralleler Urlaub (bezahlt oder unbezahlt) in der Hauptbeschäftigung", this._leaveFromMainJob, (e) => {
			this._leaveFromMainJob = e, this._handleSectionChange();
		})}
                    ${this._renderCheckboxItem("eveningSchoolStudent", "Abendschule", "Sie besuchen außerhalb der Arbeitszeit eine Abendschule oder allgemeinbildende Schule", this._eveningSchoolStudent, (e) => {
			this._eveningSchoolStudent = e, this._handleSectionChange();
		})}
                    ${this._renderCheckboxItem("seasonalHarvestWork", "Erntehilfe", "Zeitlich begrenzte saisonale Arbeit als Erntehelfer im Herkunftsland", this._seasonalHarvestWork, (e) => {
			this._seasonalHarvestWork = e, this._handleSectionChange();
		})}
                </div>
            </section>
        `;
	}
};
n([s({ type: Object }), t("design:type", Object)], l.prototype, "data", void 0), n([c(), t("design:type", Object)], l.prototype, "_registeredAsJobSeekerShortTerm", void 0), n([c(), t("design:type", Object)], l.prototype, "_receivingAgencyBenefits", void 0), n([c(), t("design:type", Object)], l.prototype, "_receivingSocialBenefits", void 0), n([c(), t("design:type", Object)], l.prototype, "_parentalLeave", void 0), n([c(), t("design:type", Object)], l.prototype, "_militaryOrVoluntaryService", void 0), n([c(), t("design:type", Object)], l.prototype, "_federalVoluntaryService", void 0), n([c(), t("design:type", Object)], l.prototype, "_startingApprenticeship", void 0), n([c(), t("design:type", Object)], l.prototype, "_startingPublicService", void 0), n([c(), t("design:type", Object)], l.prototype, "_employmentBetweenTrainingAndStudy", void 0), n([c(), t("design:type", Object)], l.prototype, "_employmentBetweenStudyAndWork", void 0), n([c(), t("design:type", Object)], l.prototype, "_employmentDuringService", void 0), n([c(), t("design:type", Object)], l.prototype, "_recentFixedTermContract", void 0), n([c(), t("design:type", Object)], l.prototype, "_sameEmployerBefore", void 0), n([c(), t("design:type", Object)], l.prototype, "_newEmploymentAfterPrevious", void 0), n([c(), t("design:type", Object)], l.prototype, "_leaveFromMainJob", void 0), n([c(), t("design:type", Object)], l.prototype, "_eveningSchoolStudent", void 0), n([c(), t("design:type", Object)], l.prototype, "_seasonalHarvestWork", void 0), l = n([o("ptc-ui-employee-questionnaire-short-term-professionalism-section")], l);
//#endregion
export { l as EmployeeQuestionnaireShortTermProfessionalismSection };

//# sourceMappingURL=short-term-professionalism-section.js.map